var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(8.5 1.5)"},[React.createElement("rect",{"id":"Podklad_burgeru","data-name":"Podklad burgeru","width":"45","height":"45","rx":"22.5","transform":"translate(-8.5 -1.5)","fill":"#00C6CC","opacity":"0","key":0}),React.createElement("path",{"data-name":"Path 185","d":"M4.5,18h20","transform":"translate(16.975 -2.91) rotate(45)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":1}),React.createElement("path",{"data-name":"Path 187","d":"M4.5,27h20","transform":"translate(-14.845 11.232) rotate(-45)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":2})]));
}

CloseIcon.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
